import { inject } from '@angular/core';
import type {
  ActivatedRouteSnapshot,
  CanActivateFn,
  RouterStateSnapshot,
} from '@angular/router';
import { NotFound } from '@freelancer/404';
import { Location } from '@freelancer/location';
import { UI_CONFIG } from '@freelancer/ui/ui.config';
import { of } from 'rxjs';

/**
 * This guard is used to check any routes that are Freightlancer specific, for pages
 * that should only be accessed on the Freightlancer domain. If a page is requested
 * from a non-Arrow domain, we will try to redirect the user to the not-found
 * page.
 */
export const FreightlancerPageGuard = (
  route: ActivatedRouteSnapshot,
  state: RouterStateSnapshot,
): ReturnType<CanActivateFn> => {
  const notFound = inject(NotFound);
  const uiConfig = inject(UI_CONFIG);
  const location = inject(Location);

  if (uiConfig.theme === 'freightlancer') {
    if ('repost_project_id' in route.queryParams) {
      const { repost_project_id, ...otherQueryParams } = route.queryParams;
      const url = state.url.split('?')[0] ?? '/';
      return location.createUrlTree([url], {
        queryParams: {
          repost_load_id: repost_project_id,
          ...otherQueryParams,
        },
        preserveFragment: true,
      });
    }

    return of(true);
  }

  return notFound.render();
};
